import {
  HHStack,
  HHToggleButton,
  HHToggleButtonGroup,
  HHTypography,
} from '@hinge-health/react-component-library';
import { Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { BillingModelType } from '../../../../types';
import { capitalizeFirstLetterAndSpaceSnakeString } from '../../../../utils/bills-utils';
import {
  isAdminFeeClaimsModelById,
  isFeeForServiceModelById,
} from '../../../../utils/contract-utils';
import { ValidBillingModel } from '../custom-package-types';
import { ContractPackageFormLabelText, fieldArrayName } from '../form';
interface BillingModelSelectProps {
  billingModels: BillingModelType[];
  index: number;
  wholeFormDisabled?: boolean;
}

const BillingModelSelect: React.FC<BillingModelSelectProps> = ({
  billingModels,
  index,
  wholeFormDisabled,
}): JSX.Element => {
  const { watch, setValue } = useFormContext();
  const watchedBillingModelId = watch(
    `selectedPackages.${index}.billingModelId`,
  );

  const filteredBillingModels = billingModels.filter(model =>
    Object.values(ValidBillingModel).includes(model.name as ValidBillingModel),
  );

  return (
    <HHStack direction="column" spacing={2}>
      <HHTypography hhVariant="caption" color="gray">
        {ContractPackageFormLabelText.BILLING_MODEL}
      </HHTypography>
      <Controller
        name={`${fieldArrayName}.${index}.billingModelId`}
        render={({ field: { onChange, value } }): JSX.Element => (
          <HHToggleButtonGroup size="medium">
            {filteredBillingModels.map(model => (
              <HHToggleButton
                data-testid={`billing-model-${model.name.toLowerCase().replace(/_/g, '-')}-button`}
                hhVariant="variant-bypass"
                key={model.id}
                value={model.id}
                onClick={(): void => {
                  onChange(model.id);
                  if (
                    isFeeForServiceModelById(billingModels, model.id) ||
                    isFeeForServiceModelById(
                      billingModels,
                      watchedBillingModelId,
                    ) ||
                    isAdminFeeClaimsModelById(billingModels, model.id) ||
                    isAdminFeeClaimsModelById(
                      billingModels,
                      watchedBillingModelId,
                    )
                  ) {
                    setValue(`${fieldArrayName}.${index}.packageId`, 0);
                  }
                }}
                selected={value === model.id}
                sx={(theme): SystemStyleObject<Theme> => ({
                  backgroundColor: 'white',
                  width: '100%',
                  textTransform: 'none',
                  '&.Mui-selected': {
                    backgroundColor: theme.palette.action.focus,
                  },
                })}
                disabled={wholeFormDisabled}
              >
                <HHTypography hhVariant="body">
                  {capitalizeFirstLetterAndSpaceSnakeString(model.name)}
                </HHTypography>
              </HHToggleButton>
            ))}
          </HHToggleButtonGroup>
        )}
      />
    </HHStack>
  );
};

export default BillingModelSelect;
